import React from 'react';

const CustomDateRangeModal = ({ 
  showModal, 
  customDateRange, 
  setCustomDateRange, 
  cancelCustomDate, 
  applyCustomDateRange 
}) => {
  return (
    <>
      {showModal && (
        <div 
          className="fixed inset-0 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm z-50 animate-in fade-in duration-200"
          key={`date-modal-${Date.now()}`}
        >
          <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-lg transform scale-100 animate-in zoom-in-95 duration-200">
            <div className="p-6 border-b border-gray-100">
              <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold text-gray-800">Select Date Range</h2>
                <button 
                  onClick={cancelCustomDate}
                  className="text-gray-400 hover:text-gray-600 transition-colors p-1 hover:bg-gray-100 rounded-lg"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
                  <div className="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <input
                      type="date"
                      value={customDateRange.start}
                      onChange={(e) =>
                        setCustomDateRange({
                          ...customDateRange,
                          start: e.target.value,
                        })
                      }
                      className="w-full pl-11 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#F16745]/20 focus:border-[#F16745] transition-all duration-200"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
                  <div className="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <input
                      type="date"
                      value={customDateRange.end}
                      onChange={(e) =>
                        setCustomDateRange({
                          ...customDateRange,
                          end: e.target.value,
                        })
                      }
                      className="w-full pl-11 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#F16745]/20 focus:border-[#F16745] transition-all duration-200"
                    />
                  </div>
                </div>
              </div>

              {(customDateRange.start || customDateRange.end) && (
                <div className="mt-6 p-4 bg-[#F16745]/5 rounded-xl border border-[#F16745]/10">
                  <p className="text-sm text-[#F16745] font-medium">
                    {customDateRange.start ? new Date(customDateRange.start).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric'
                    }) : ''} 
                    {customDateRange.start && customDateRange.end ? ' - ' : ''} 
                    {customDateRange.end ? new Date(customDateRange.end).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric'
                    }) : ''}
                  </p>
                </div>
              )}
            </div>

            <div className="p-6 bg-gray-50 rounded-b-2xl border-t border-gray-100">
              <div className="flex justify-end space-x-3">
                <button
                  onClick={cancelCustomDate}
                  className="px-4 py-2.5 bg-white border border-gray-200 rounded-xl text-gray-600 font-medium hover:bg-gray-50 transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={applyCustomDateRange}
                  className="px-4 py-2.5 bg-[#F16745] rounded-xl text-white font-medium hover:bg-[#F16745]/90 transition-colors duration-200"
                >
                  Apply Range
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomDateRangeModal; 